import { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Dashboard } from './pages/Dashboard';
import { Profile } from './pages/Profile';
import { NotFound } from './pages/NotFound';
import { Spinner } from '@bapecom/ui';
import { useRoutes } from '@bapecom/app-registry';

// Loading fallback component
const AppLoader = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <Spinner size="lg" />
  </div>
);

// Dynamic app routes from registry
const AppRoutes = () => {
  const routes = useRoutes();
  
  return (
    <>
      {routes.map((route) => (
        <Route
          key={route.path}
          path={route.path.replace('/apps/', 'apps/')}
          element={
            <ProtectedRoute appId={route.permissionId} requireAdmin={route.requireAdmin}>
              <Suspense fallback={<AppLoader />}>
                <route.component />
              </Suspense>
            </ProtectedRoute>
          }
        />
      ))}
    </>
  );
};

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="profile" element={<Profile />} />
        
        {/* Dynamic app routes from registry */}
        {AppRoutes()}

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default App;
